module.exports = __webpack_public_path__ + "img/declaration-lazy.21d9b4da.jpg";